export default "__VITE_ASSET__BSSiG9bO__"